var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"inline-block","width":"100%"}},[_vm._v(" "+_vm._s(_vm.defaultText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }